/* eslint-disable import/no-anonymous-default-export */

import error from './en-US/error';
import exception from './en-US/exception';
import field from './en-US/field';
import general from './en-US/general';
import project from './en-US/project';
import projectItem from './en-US/projectItem';

export default {
  ...general,
  ...field,
  ...project,
  ...projectItem,
  ...error,
  ...exception,
};

